module.exports = __webpack_public_path__ + "fonts/proximanovasoft-regular-webfont.391b3f7.eot";